<template>
  <BBreadcrumb v-if="breadcrumbsStoreData.items.length > 0"
               class="px-i"
               :items="breadcrumbsStoreData.items" />
</template>

<script>
import { BBreadcrumb } from 'bootstrap-vue';
import BreadcrumbsStore from '../../stores/BreadcrumbsStore';

export default {
  name: 'Header',

  components: {
    BBreadcrumb
  },

  data () {
    return {
      breadcrumbsStoreData: BreadcrumbsStore.data
    };
  }
};
</script>
